<template>
  <AdsButton
    v-bind="$attrs"
    :loading="$store.state.isLoading"
    secondary
    outlined
    button-text="Publish"
    v-on="$listeners"
  />
</template>

<script>
import {AdsButton} from '@nswdoe/doe-ui-core';

export default {
  name: 'PublishButton',
  components: {AdsButton}
}
</script>

<style lang="scss" scoped>

</style>
